import { Box } from "@mui/system";
import { useRef, useState } from "react";
import { Timer } from "../entities";
import { useKronosCurrentTimer } from "../../redux/kronos/kronosHooks";
import {
  useCreateKronosTimerMutation,
  useUpdateKronosTimerMutation,
} from "../../redux/kronos/kronosEndpoints";
import { KronosTimerChip } from "./kronosTimerChip";
import { KronosTimerPopper } from "./kronosTimerPopper";

/**
 *
 * @returns {ReactElement} KronosTimer page
 */
export function KronosTimer({ size, helmet }: KronosTimerType) {
  const [_open, setOpen] = useState(false);
  const ref = useRef();
  const { currentTimer } = useKronosCurrentTimer();
  const [createTimer] = useCreateKronosTimerMutation();
  const [updateTimer] = useUpdateKronosTimerMutation();

  const onChange = async (t: Partial<Timer>) => {
    if (t?.id) {
      await updateTimer({ id: t.id, body: t });
    } else {
      await createTimer(t);
    }
  };

  return (
    <Box>
      <Box ref={ref}>
        <KronosTimerChip
          size={size}
          helmet={helmet}
          onClick={() => setOpen((o) => !o)}
          timer={currentTimer}
          tooltip={_open ? "Close Timer" : "Open Timer"}
        />
      </Box>
      <KronosTimerPopper
        anchorEl={ref.current}
        open={_open}
        onChange={onChange}
        timer={currentTimer}
        onClose={() => setOpen(false)}
      />
    </Box>
  );
}

type KronosTimerType = {
  helmet?: boolean;
  size?: "sm" | "md" | "lg" | undefined;
};
